// extracted by mini-css-extract-plugin
export default {"container":"conference-page_container__PKkgu"};